var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38456 3.8769C2.72774 3.8769 1.3846 5.22003 1.3846 6.87692V13.6154C1.3846 15.2722 2.72774 16.6154 4.38456 16.6154H11.7691C13.426 16.6154 14.7691 15.2722 14.7691 13.6154V6.87692C14.7691 5.22003 13.426 3.8769 11.7691 3.8769H4.38456ZM0 6.87692C0 4.45534 1.96304 2.49228 4.38456 2.49228H11.7691C14.1906 2.49228 16.1537 4.45534 16.1537 6.87692V13.6154C16.1537 16.0369 14.1906 18 11.7691 18H4.38456C1.96304 18 0 16.0369 0 13.6154V6.87692Z",
    fill: "#D9808A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75382 0C5.1362 0 5.44613 0.309955 5.44613 0.692309V3.18462C5.44613 3.567 5.1362 3.87693 4.75382 3.87693C4.37151 3.87693 4.06152 3.567 4.06152 3.18462V0.692309C4.06152 0.309955 4.37151 0 4.75382 0Z",
    fill: "#D9808A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3998 0C11.7822 0 12.0921 0.309955 12.0921 0.692309V3.18462C12.0921 3.567 11.7822 3.87693 11.3998 3.87693C11.0175 3.87693 10.7075 3.567 10.7075 3.18462V0.692309C10.7075 0.309955 11.0175 0 11.3998 0Z",
    fill: "#D9808A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 6.64626H15.5537V8.03087H0.600098V6.64626Z",
    fill: "#D9808A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95996 10.6614C3.95996 10.279 4.26995 9.96911 4.65226 9.96911H4.85536C5.23773 9.96911 5.54766 10.279 5.54766 10.6614C5.54766 11.0438 5.23773 11.3537 4.85536 11.3537H4.65226C4.26995 11.3537 3.95996 11.0438 3.95996 10.6614Z",
    fill: "#D9808A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75684 10.6614C6.75684 10.279 7.06677 9.96911 7.44914 9.96911H8.70447C9.08684 9.96911 9.39677 10.279 9.39677 10.6614C9.39677 11.0438 9.08684 11.3537 8.70447 11.3537H7.44914C7.06677 11.3537 6.75684 11.0438 6.75684 10.6614Z",
    fill: "#D9808A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.606 10.6614C10.606 10.279 10.9159 9.96911 11.2983 9.96911H11.5014C11.8837 9.96911 12.1937 10.279 12.1937 10.6614C12.1937 11.0438 11.8837 11.3537 11.5014 11.3537H11.2983C10.9159 11.3537 10.606 11.0438 10.606 10.6614Z",
    fill: "#D9808A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95996 13.9848C3.95996 13.6024 4.26995 13.2925 4.65226 13.2925H6.14763C6.53 13.2925 6.83993 13.6024 6.83993 13.9848C6.83993 14.3672 6.53 14.6771 6.14763 14.6771H4.65226C4.26995 14.6771 3.95996 14.3672 3.95996 13.9848Z",
    fill: "#D9808A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01221 13.9848C8.01221 13.6024 8.32219 13.2925 8.70451 13.2925H8.9076C9.28997 13.2925 9.5999 13.6024 9.5999 13.9848C9.5999 14.3672 9.28997 14.6771 8.9076 14.6771H8.70451C8.32219 14.6771 8.01221 14.3672 8.01221 13.9848Z",
    fill: "#D9808A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.606 13.9848C10.606 13.6024 10.9159 13.2925 11.2983 13.2925H11.5014C11.8837 13.2925 12.1937 13.6024 12.1937 13.9848C12.1937 14.3672 11.8837 14.6771 11.5014 14.6771H11.2983C10.9159 14.6771 10.606 14.3672 10.606 13.9848Z",
    fill: "#D9808A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.2f204df4e5545d676bf4660dc4e14816.svg";
export { ForwardRef as ReactComponent };